import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StudentDataService } from '../services/student-data.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  // Since we wrap all of the routes as children for this AuthGuard, we
  // need to check the children of the route snapshot to get the furthest
  // nested child route to see if the route needs to be authenticated or not.
  let deepestChild: ActivatedRouteSnapshot = route;
  while (deepestChild.firstChild)
  {
    deepestChild = deepestChild.firstChild;
  }

  const studentDataService = inject(StudentDataService);
  const router = inject(Router);
  let isUnauthorizedRoute: boolean = deepestChild.data.needs_auth === false;
  if (!studentDataService.isLoggedIn() && !isUnauthorizedRoute)
  {
    return router.createUrlTree(['/login']);
  }

  if (state.url === '/demo' && !studentDataService.isDemoUser())
  {
    // Navigate back to the current page if the user tries to
    // navigate to the demo page and is not authorized.
    return router.createUrlTree(['..']);
  }

  return true;
}
